import { render, staticRenderFns } from "./addcompanychecktemplate.html?vue&type=template&id=5582d5f1&external"
import script from "./addcompanychecktemplate.vue?vue&type=script&lang=js"
export * from "./addcompanychecktemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports